import { c as _c } from "react/compiler-runtime";
import { formatUser, useUpdateUser } from '@netpurpose/api';
import { useLoggedIn } from '@netpurpose/core';
import { useNotification } from '@netpurpose/np-ui';
import { DEMO_METRIC_CONFIG } from '@netpurpose/types';
import { config } from '#services/config';

// Lets the sales team reset their user to a clean slate before a demo
// Clears localstorage and resets metric config to Net Purpose Demo
export const useResetDemoUser = () => {
  const $ = _c(4);
  const {
    user
  } = useLoggedIn();
  const {
    updateUser
  } = useUpdateUser();
  const {
    openNotification
  } = useNotification();
  let t0;
  if ($[0] !== openNotification || $[1] !== updateUser || $[2] !== user) {
    const resetDemoUser = () => {
      if (!user) {
        return;
      }
      updateUser({
        body: formatUser({
          ...user,
          defaultMetricsConfigId: DEMO_METRIC_CONFIG,
          group: user.groups[0]?.groupId as string
        }),
        path: {
          user_id: user.id
        }
      }, {
        onSuccess: _temp,
        onError: () => {
          openNotification({
            title: "Unable to reset user",
            message: "Something went wrong resetting the default metric configuration.",
            type: "error",
            raised: true
          });
        }
      });
    };
    t0 = {
      resetDemoUser
    };
    $[0] = openNotification;
    $[1] = updateUser;
    $[2] = user;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp() {
  localStorage.clear();
  window.location.assign(config.routes.landingPage);
}